import React from 'react';

const PageHeader = ({ title, subtitle, actions }) => {
  return (
    <div className="user-home-layout__page-header">
      <div className="user-home-layout__page-header-main">
        <h1 className="user-home-layout__page-title">{title}</h1>
        {subtitle && (
          <p className="user-home-layout__page-subtitle">{subtitle}</p>
        )}
      </div>
      {actions && (
        <div className="user-home-layout__page-actions">{actions}</div>
      )}
    </div>
  );
};

export default PageHeader;

